import { api } from '@/lib/api/client';

export type GoalMetric =
  | 'samples'
  | 'responses'
  | 'leads'
  | 'prizesDelivered'
  | 'completionRate';

/** De dónde sale la meta que rige: fijada en el evento o heredada del proyecto. */
export type GoalSource = 'event' | 'project';

/**
 * Lo que devuelve `GET /xk-event/:id/goals`: las metas que RIGEN en el evento.
 * Las suyas llevan `source: 'event'`; las que no fijó llegan enteras del
 * proyecto con `source: 'project'`.
 */
export interface EventGoal {
  metric: GoalMetric;
  targetValue: number;
  source: GoalSource;
}

/** Una meta fijada en el proyecto (`xk_event_group_goals`). */
export interface ProjectGoal {
  id: number;
  eventGroupId: number;
  metric: GoalMetric;
  targetValue: number;
}

export interface GoalProgress {
  metric: GoalMetric;
  target: number;
  actual: number;
  percent: number;
  status: 'on-track' | 'at-risk' | 'met';
  source: GoalSource;
}

export const goalsApi = {
  list: (eventId: number) =>
    api.get<EventGoal[]>(`/xk-event/${eventId}/goals`),
  upsert: (eventId: number, metric: GoalMetric, targetValue: number) =>
    api.put<{ id: number }>(`/xk-event/${eventId}/goals/${metric}`, {
      targetValue,
    }),
  remove: (eventId: number, metric: GoalMetric) =>
    api.delete<{ ok: true }>(`/xk-event/${eventId}/goals/${metric}`),
  progress: (eventId: number) =>
    api.get<GoalProgress[]>(`/xk-event/${eventId}/goal-progress`),
};

export const projectGoalsApi = {
  list: (groupId: number) =>
    api.get<ProjectGoal[]>(`/xk-event-group/${groupId}/goals`),
  upsert: (groupId: number, metric: GoalMetric, targetValue: number) =>
    api.put<ProjectGoal>(`/xk-event-group/${groupId}/goals/${metric}`, {
      targetValue,
    }),
  remove: (groupId: number, metric: GoalMetric) =>
    api.delete<{ ok: true }>(`/xk-event-group/${groupId}/goals/${metric}`),
};
